function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from "react";
import { ChromePicker } from "react-color";
/**
 * Common color picker compnent.
 *
 * Example usage:
 *
 * <ColorPicker
 *         name="input_name"
 *         value="default_value"
 *         label="Some Label"
 *         changeHandle={this.handleChange} />
 *
 * @class ColorPicker
 * @extends {Component}
 */

var ColorPicker = /*#__PURE__*/function (_Component) {
  _inherits(ColorPicker, _Component);

  var _super = _createSuper(ColorPicker);

  function ColorPicker(props) {
    var _this;

    _classCallCheck(this, ColorPicker);

    _this = _super.call(this, props);
    _this.state = {};
    _this.toggleColorPicker = _this.toggleColorPicker.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Hide or show the color picker.
   *
   * @memberof ColorPicker
   */


  _createClass(ColorPicker, [{
    key: "toggleColorPicker",
    value: function toggleColorPicker() {
      this.setState({
        showPicker: !this.state.showPicker
      });
    }
    /**
     * Generate an rgba string which we can then store in the config.
     *
     * @param {*} color
     * @returns
     * @memberof ColorPicker
     */

  }, {
    key: "rgbaString",
    value: function rgbaString(color) {
      return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var picker = null;
      var name = this.props.name;
      var value = this.props.value;

      if (this.state.showPicker) {
        picker = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          style: {
            position: "absolute",
            zIndex: "2"
          }
        }, /*#__PURE__*/React.createElement(ChromePicker, {
          onChange: function onChange(color) {
            _this2.props.changeHandler(name, _this2.rgbaString(color.rgb));
          },
          color: value
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            position: "fixed",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0
          },
          onClick: this.toggleColorPicker
        }));
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "gameo-input-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "width"
      }, this.props.label), /*#__PURE__*/React.createElement("input", {
        className: "browser-default gameo-input",
        onChange: function onChange(value) {
          return _this2.props.changeHandler(name, value);
        },
        onFocus: this.toggleColorPicker,
        type: "text",
        name: name,
        value: value
      })), picker);
    }
  }]);

  return ColorPicker;
}(Component);

export { ColorPicker as default };